export default __webpack_public_path__ + "static/16-4b70c5214c2f609c130dd4263d7df953.webp";